import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');
//let serverUrl = ("http://localhost:3000")
import i18n from '@plugins/i18n'

export const getters = {
  getFileFields() {
    return {model: 'repositories_file', 
            label: 'Files',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
              ]}
  },
}

export const actions = {
  async fetchFiles(context, query = '') {
    return axios
    .get(`${serverUrl}/api/masters/files/${query}`)
      .then((response) => {
        return response.data;   
      })
  },

  async createFiles(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/files/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateFiles(context, { payload }) {
    return axios
    .patch(`${serverUrl}/api/masters/files/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteFiles(context, { id }) {
    return axios
    .delete(`${serverUrl}/api/masters/files/${id}/`)
      .then((response) => {
        return response.data;
      })
  }
}